import { observer } from "mobx-react-lite";

import { StepRenderProps } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import { FC } from "react";
import { OnboardingPermissionsRestartScreen } from "@/components/onboarding/components/welcome-wizard/steps/system-permission-voice/components";

export const SystemPermissionsRestartIfRequiredStep: FC<StepRenderProps> = observer(
  ({ onClose }) => {
    const handleClose = () => {
      onClose?.();
    };

    return <OnboardingPermissionsRestartScreen onClose={handleClose} />;
  }
);
